export const Animations = {
  SlideInLeft: 'slide-in-left',
  SlideInLeft300: 'slide-in-left-300',
  SlideInRight: 'slide-in-right',
  FadeInInputs: 'fade-in-inputs',
  SelectionTabs: 'selection-tabs',
} as const
export type Animations = (typeof Animations)[keyof typeof Animations]
